import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import MobileBottomNav from "./MobileBottomNav";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-brand-ivory">
      <Navbar />
      <main className="flex-1 pb-24 md:pb-0" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}
